import { Divider } from 'antd'
import React, { useEffect, useState } from 'react'
import Input from '../../components/UI/Input'
import { addAddition, getAvaliableGamesWithWager, getJackpotsById, saveJackpot } from '../../services/jackpots';
import { useLoading } from '../../context/LoadingProvider/useLoading';
import SelectInput from '../../components/UI/SelectInput';
import { useNavigate, useParams } from 'react-router-dom';
import SwitchInput from '../../components/UI/SwitchInput';
import { onlyNumbers } from '../../utils/formValidation';
import Button from '../../components/UI/Button';
import CancelButton from '../../components/CancelButton';
import { notificationError } from '../../services/notification';
import { InputMode } from '../../enums/inputTypeEnum';

export interface IAvaliableGamesByWager {
  [key: string]: {name: string, id: string}[]
}

export interface IJackpotInfo {
  name:string,
  houseSeed:string,
  contributionPercent:string,
  wagerText:string,
  gameIds:string[],
  instanceId?:string,
  templateId?:string,
  active:boolean,
  currentValue?: string,
  additions?:IJackpotAddition[]
}

export interface IJackpotAddition {
  jackpot_id: string,
  value:string,
  reason:string,
  time:string
}

function index() {
  const loading = useLoading()
  const history = useNavigate()
  const {id} = useParams()
  const [form, setForm] = useState<IJackpotInfo>({
    name:"",
    houseSeed:"$100",
    contributionPercent:"10%",
    wagerText:"",
    instanceId:"",
    gameIds:[],
    active:true
  })
  const [orig, setOrig] = useState<IJackpotInfo>({
    name:"",
    houseSeed:"$100",
    contributionPercent:"10%",
    wagerText:"",
    instanceId:"",
    gameIds:[],
    active:true
  })
  const [avaliableGames, setAvaliableGames] = useState<IAvaliableGamesByWager>({})
  const [selectedWager, setSelectedWager] = useState('')
  const [selectedGameIds, setSelectedGameIds] = useState<string[]>([])
  const [additionForm, setAdditionForm] = useState({
    value: '',
    reason: '',
  })
  const [additions, setAdditions] = useState<IJackpotAddition[]>([])

  const isChanged = () => {
    if(!form.name || !form.houseSeed || !form.contributionPercent
        //|| !form.wagerText
        || !form.gameIds
        || !form.active
    ) return false
    if(form.houseSeed!==orig.houseSeed) return true
    if(form.name!==orig.name) return true
    if(form.contributionPercent!==orig.contributionPercent) return true
    if(form.wagerText!==orig.wagerText) return true
    if(form.instanceId!==orig.instanceId) return true
    if(form.gameIds.toString()!==orig.gameIds.toString()) return true
    if(selectedGameIds.length>0) return true
    return form.active !== orig.active;

  }

  useEffect(() => {
    (async ()=> {
      loading.addLoading()
      const games = await getAvaliableGamesWithWager()
      setAvaliableGames(games)
      let selectedWager = Object.keys(games)[0]
      if(id) {
        const jackpot = await getJackpotsById({id})
        setForm({
          ...jackpot,
          houseSeed: '$' + onlyNumbers(jackpot.houseSeed.split('.')[0] || ''),
          contributionPercent: onlyNumbers(jackpot.contributionPercent.split('.')[0] || '') + '%',
        })
        setOrig({
          ...jackpot,
          houseSeed: '$' + onlyNumbers(jackpot.houseSeed.split('.')[0] || ''),
          contributionPercent: onlyNumbers(jackpot.contributionPercent.split('.')[0] || '') + '%',
        })

        setAdditions(jackpot.additions || [])
        Object.keys(games).forEach((game) => {
          if(games[game].find(({id}) => id === jackpot.gameIds[0])) {
            selectedWager = game
          }
        })
      }
      setSelectedWager(selectedWager)
      loading.removeLoading()
    })()
  },[])

  const numberToCurrency = (value: string) => {
    let currency = value ? onlyNumbers(value) : 0
    setForm({...form, houseSeed: `$${currency}`})
  }

  const handlePercentageChange = (value: string) => {
    let inputValue = value
    inputValue = inputValue.replace(/[^0-9.]/g, '');
    inputValue = inputValue.replace(/(\..*)\./g, '$1');
    inputValue = inputValue.replace(/^(-?)0+(?=\d)/, '$1');
    inputValue = inputValue.replace(/^(-?[0-9]+\.[0-9]{1}).*$/, '$1');
    const percentageValue = `${inputValue}%`;
    return percentageValue
  }

  useEffect(() => {
    setSelectedGameIds([])
  },[selectedWager])

  const addOrRemoveGameId = (e: boolean, gameId: string) => {
    if(e) return setSelectedGameIds([...selectedGameIds, gameId])

    const games = [...selectedGameIds]
    const index = games.indexOf(gameId)
    games.splice(index, 1)    
    if(index !== -1) return setSelectedGameIds(games)

    const serverGames = [...form.gameIds]
    const serverIndex = serverGames.indexOf(gameId)
    serverGames.splice(serverIndex, 1)
    if(serverIndex !== -1) return setForm({...form, gameIds: serverGames})
  }

  const onSaveJackpot = async () => {
    const contributionPercent = parseFloat(form.contributionPercent.replace('%', ''))
    const houseSeed = onlyNumbers(form.houseSeed)
    const gameIds = [...form.gameIds, ...selectedGameIds]
    const wagerText = selectedWager

    const MIN_CONTRIB_PERCENT = 0;
    const MAX_CONTRIB_PERCENT = 100

    if(!form.name) return notificationError('The name field is required')
    if(!contributionPercent) return notificationError('The field contribution percent is required')
    if(contributionPercent < MIN_CONTRIB_PERCENT || contributionPercent > MAX_CONTRIB_PERCENT) return notificationError('Contribution must be between greater than 0 and lower than 100')
    if(gameIds.length!==1) return notificationError('One and only one game can be selected')

    loading.addLoading()
    const res = await saveJackpot({
      ...form,
      wagerText,
      gameIds,
      houseSeed,
      contributionPercent
    })
    loading.removeLoading()
    
    if(res) history('/jackpots/list')
  }

  const onAddAddition = async () => {
    if(!additionForm.reason) return notificationError('The reason field is required')
    if(!additionForm.value || !onlyNumbers(additionForm.value)) notificationError('The value field is required')

    loading.addLoading()
    const res = await addAddition({
      ...additionForm,
      jackpot_id: form.instanceId
    })
    loading.removeLoading()
    if(res) history('/jackpots/list')
  }
  
  return (
    <div className="new-jackpot">
      <div className="new-jackpot__container">
        <Divider orientation="left"><strong>General info</strong></Divider>
        <div className="new-jackpot__container__row">  
          <Input
            label="Name*"
            placeholder="Name"
            value={form.name}
            onChange={(e: any) => setForm({...form, name: e.target.value})}
          />
          <Input
            label="House seed*"
            placeholder="$100"
            value={form.houseSeed}
            onChange={(e: any) => numberToCurrency(e.target.value)}
          />
          <Input
            label="Contribution percent*"
            placeholder="10%"
            value={form.contributionPercent}
            onChange={(e) => setForm({...form, contributionPercent: handlePercentageChange(e.target.value)})}
          />
          <SelectInput
            label="Wager"
            options={Object.keys(avaliableGames).map((key) => {return {name: key, value: key}})}
            onSelectChange={(e) => setSelectedWager(e?.value ? e.value : e)}
            value={selectedWager}
          />
          <Divider />
          <div className="new-jackpot__games">
            <div><strong>Games</strong></div>
            {avaliableGames[selectedWager]?.map((game)=> (
              <SwitchInput
                label={game.name + ' - ' + game.id}
                onChange={(e) => addOrRemoveGameId(e, game.id)}
                options={{check: true, uncheck: false}}
                value={!!form.gameIds.find(gameId => gameId === game.id) || !!selectedGameIds.find(gameId => gameId === game.id)}
              />
            ))}
          </div>
        </div>
        <div className="new-jackpot__controls">
          <CancelButton />
          <Button type="primary"
            onClick={onSaveJackpot}
            disabled={!isChanged()}
          >
            <p>Save</p>
          </Button>
        </div>
        {id && form.active && (
          <>
            <Divider orientation="left"><strong>Additions</strong></Divider>
            <div className="new-jackpot__additions">
              <h3>Current Jackpot {form.currentValue || ''}</h3>
              <div className="new-jackpot__additions__list">
                <table>
                  <tr className="new-jackpot__additions__list__head">
                    <th>Value</th>
                    <th>Reason</th>
                    <th>Time</th>
                  </tr>
                  {additions.map((addition) => (
                    <tr>
                      <td>{addition.value}</td>
                      <td>{addition.reason}</td>
                      <td>{addition.time}</td>
                    </tr>
                  ))}
                </table>
              </div>
              <div className="new-jackpot__additions__form">
                <Input
                  label="Value*"
                  placeholder="value"
                  value={additionForm.value}
                  onChange={(e) => setAdditionForm({...additionForm, value: e.target.value})}
                  type="number"
                  allowNegative
                  inputMode={InputMode.CURRENCY}
                />
                <Input
                  label="Reason*"
                  placeholder="Reason"
                  value={additionForm.reason}
                  onChange={(e) => setAdditionForm({...additionForm, reason: e.target.value})}
                  style={{width: '40vw', minWidth: 300}}
                />
                <Button 
                  type="primary" 
                  onClick={() => onAddAddition()}
                  style={{height: 32, marginTop: 24}}
                  disabled={!additionForm.value || !additionForm.reason}
                >
                  <p>Add</p>
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
      <p>* Indicates required fields</p>
    </div>
  )
}

export default index